<template>
  <!-- 门店、处方列表监管账号搜索 -->
  <el-form :model="formData" class="search-box">
    <el-form-item class="fl" v-permission="'h'">
      <el-select v-model="formData.cityCode" placeholder="市" @change="getAreasData" clearable>
        <el-option v-for="item of cityAreas" :key="item.label" v-bind="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="fl" v-permission="'h,i'">
      <el-select
        v-model="formData.distrCode"
        placeholder="区"
        :disabled="$checkPower('h') && !formData.cityCode"
        clearable
      >
        <el-option v-for="item of distrAreas" :key="item.label" v-bind="item"></el-option>
      </el-select>
    </el-form-item>
    <div class="select_from_store_name fl">
      <label-input label="公司名称" placeholder="请输入公司名称" width="280px" v-model="formData.companyName" />
    </div>
    <template v-if="$route.name !== 'shopManagement'">
      <div class="select_from_store_name fl">
        <slot name="drugName"></slot>
      </div>
      <div class="select_from_store_name fl">
        <label-input
          label="门店名称"
          placeholder="请输入门店名称"
          width="280px"
          type="autocomplete"
          v-model="formData.drugstore"
          :_parent="_self"
        />
      </div>
      <el-form-item class="fl">
        <el-date-picker
          v-model="formData.date"
          value-format="YYYY-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          type="daterange"
          :default-value="defaultDateValue"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          class="zy-date-picker"
          v-bind="dateProps"
          v-on="dateEvent"
        />
      </el-form-item>
    </template>
    <div class="select_from_store_name fl" v-else>
      <label-input label="门店名称" placeholder="请输入门店名称" width="280px" v-model="formData.storeName" />
    </div>
    <el-form-item class="fl">
      <el-button type="info" plain @click="onSubmit" class="search-btn">查询</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Constant from '@/lib/constant';
import { delObjectEmpty } from '@/util';
import Fetch from '../api';
import { dateLimit } from '@/util/mixins';
import dayjs from 'dayjs';
// import AbsurdDatePicker from 'src/components/'

export default {
  name: 'breadTab',
  components: { labelInput },
  mixins: [dateLimit()],
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {
          patientName: '',
          date: '',
          prescriptionTotalStatus: '',
          advisoryType: ''
        };
      }
    }
  },
  data() {
    return {
      formData: {
        cityCode: '',
        distrCode: '',
        companyName: '',
        storeName: '',
        date: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      searchStatus: Constant.searchStatus,
      advisoryTypes: Constant.advisoryTypes,
      cityAreas: [],
      distrAreas: [],
      defaultDateValue: [
        dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ]
    };
  },
  watch: {
    searchData: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    }
  },
  created() {
    const { placeCode } = this.$store.state.global;
    this.getAreasData(placeCode);
  },
  mounted() {
    setTimeout(() => {
      this.formData.date = [...this.defaultDateValue];
    }, 50);
  },
  methods: {
    getAreasData(districtCode) {
      if (!districtCode) return (this.formData.distrCode = '');
      Fetch.getAreas({ districtCode }).then(res => {
        if (!res || !res.length) return;
        const level = res[0].level;
        const data = res.map(({ districtName: label, districtCode: value }) => ({ label, value }));
        level === 3 && (this.cityAreas = data);
        level === 4 && (this.distrAreas = data);
      });
    },
    onSubmit() {
      const params = delObjectEmpty(this.formData);
      if (this.$route.name === 'shopManagement') {
        delete params.date;
      }
      this.$emit('search', params);
      this.$store.commit('prescription/SET_SEARCH_DATA', params);
    },
    setFormStoreId(val) {
      this.formData.storeId = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.select_from_store_name {
  float: left;
  margin-right: 16px;
}
.select_from_user_name {
  float: left;
  margin-right: 16px;
  margin-bottom: 16px;
  height: 40px;
  overflow: hidden;
}
.fl {
  float: left;
  margin-right: 16px;
  margin-bottom: 16px;
  height: 40px;
}
.fr {
  float: right;
  margin-right: 16px;
}
.last {
  margin-right: 0;
}
.link {
  width: 176px;
  background: #fff !important;
  color: #bdbdbd !important;
  text-align: left;
  padding: 12px 12px;
  span {
    i {
      float: right;
    }
  }
  &:hover {
    color: #bdbdbd !important;
  }
}
.search-btn {
  background: #1e8dff !important;
  color: #fff !important;
  height: 40px !important;
  width: 80px !important;
  color: #1e8dff !important;
  background: #ffffff !important;
  border: 1px solid #1e8dff !important;
  &:hover {
    background: #1e8dff !important;
  }
}
</style>
